<template>
  <div v-if="Object.keys(trip_data).length > 0">
    <b-modal id="aatkings-trip-info-modal" ref="aatkings-trip-info-modal-ref" hide-footer title="Trip Information">
      <div v-for="(image, index) in trip_data.images" :key="`images_header - ${index}`">
        <div class="modal-banner-container" v-if="image.type === 'header_image'">
          <img :src="image.href" class="vtd-center-image" />
          <div class="modal-banner-text">{{ trip_data.trip.name }}</div>
        </div>
      </div>
      <div>
        <h4 class="mt-3 orange">Introduction</h4>
        <p class="text-left" v-html="trip_data.trip.overview"></p>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold" v-if="trip_data.trip.countries.length === 1">
          Country:
        </div>
        <div class="col-md-4 vtd-font-weight-bold" v-if="trip_data.trip.countries.length > 1">
          Countries:
        </div>
        <div class="col-md-8">
          <span v-for="(country, index) in trip_data.trip.countries" :key="index">{{ country
          }}<span v-if="index !== trip_data.trip.countries.length - 1">,
            </span></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Start City:</div>
        <div class="col-md-8">
          {{ trip_data.trip.start_city }}, {{ trip_data.trip.start_country }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">End City:</div>
        <div class="col-md-8">
          {{ trip_data.trip.end_city }}, {{ trip_data.trip.end_country }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Duration:</div>
        <div class="col-md-8">{{ trip_data.trip.duration }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Trip Style:</div>
        <div class="col-md-8">{{ trip_data.trip.trip_style }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Trip Code:</div>
        <div class="col-md-8">{{ trip_data.trip.trip_code }}</div>
      </div>
      <div>
        <h4 class="mt-3 orange">Trip Map</h4>
        <div v-for="(image, index) in trip_data.images" :key="`images_map-${index}`">
          <div v-if="image.type === 'map_image'">
            <img :src="image.href" class="vtd-center-image" />
          </div>
        </div>
      </div>
      <h4 class="mt-3 orange">Itinerary</h4>
      <div v-for="obj in trip_data.itinerary" v-bind:key="obj.day" class="itinerary-container">
        <h6 class="orange">
          Day {{ obj.day }}
          <span v-for="(location, index) in obj.locations" :key="index">
            {{ location }}</span>
        </h6>
        <p class="vtd-font-weight-bold">{{ obj.title }}</p>
        <p v-for="(element, index) in obj.text" :key="index">{{ element }}</p>
        <div class="inclusion-container" v-if="obj.accommodation">
          <h5 class="vtd-font-weight-bold">Accommodation:</h5>
          <p>{{ obj.accommodation }}</p>
        </div>
        <div class="inclusion-container" v-if="obj.meals">
          <h5 class="vtd-font-weight-bold" v-if="obj.meals.length === 1">
            Meal:
          </h5>
          <h5 class="vtd-font-weight-bold" v-if="obj.meals.length > 1">
            Meals:
          </h5>
          <span v-for="(meal, index) in obj.meals" :key="index">
            {{ meal }}<span v-if="index !== obj.meals.length - 1">, </span>
          </span>
        </div>
      </div>
      <template>
        <div>
          <h4 class="mt-3 orange">Gallery</h4>
          <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ffffff"
            img-width="1024" img-height="480" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
            <div v-for="(image, index) in trip_data.images" :key="`images_gallery- ${index}`">
              <b-carousel-slide v-if="image.type === 'gallery_image'" :img-src="image.href"
                class="image-size"></b-carousel-slide>
            </div>
          </b-carousel>
        </div>
      </template>
      <div v-if="trip_data.trip.activities || trip_data.trip.inclusions">
        <h4 class="mt-3 orange">Inclusions</h4>
        <div v-if="trip_data.trip.activities.length > 0">
          <div class="vtd-font-weight-bold" v-if="trip_data.trip.activities.length === 1">
            Activity
          </div>
          <div class="vtd-font-weight-bold" v-if="trip_data.trip.activities.length > 1">
            Activities
          </div>
          <ul class="">
            <li v-for="(activity, index) in trip_data.trip.activities" :key="index">
              {{ activity }}
            </li>
          </ul>
        </div>
        <div v-if="trip_data.trip.inclusions.length > 0">
          <div class="vtd-font-weight-bold" v-if="trip_data.trip.inclusions.length === 1">
            Inclusion
          </div>
          <div class="vtd-font-weight-bold" v-if="trip_data.trip.inclusions.length > 1">
            Inclusions
          </div>
          <ul>
            <li v-for="(inclusion, index) in trip_data.trip.inclusions" :key="index">
              {{ inclusion }}
            </li>
          </ul>
        </div>
      </div>
      <div v-if="trip_data.trip.notes">
        <h4 class="mt-3 orange">Trip Notes</h4>
        <p v-for="(note, index) in trip_data.trip.notes" :key="index">
          {{ note }}
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { fetchAATKingsData } from "../../modules/booking/tours/services";

export default {
  props: {
    item: null,
  },
  data() {
    return {
      trip_data: {},
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    returnDays() {
      if (
        this.trip_data &&
        this.trip_data.itinerary &&
        Array.isArray(this.trip_data.itinerary)
      ) {
        return this.trip_data.itinerary.length;
      }
      return "";
    },
  },
  async mounted() {
    this.trip_data = await fetchAATKingsData(this.item.esctourcode, this.item.tourdate);
  },
  methods: {
    show(htlpagelink) {
      this.$refs["aatkings-trip-info-modal-ref"].show();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
  height: 30rem;
  overflow: hidden;
}

.modal-banner-text {
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.itinerary-container {
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.inclusion-container {
  background-color: #dbdbdb;
  margin: 10px;
  padding: 10px;
}

.address {
  text-indent: 40px;
}

.image-size {
  height: 55vh;
}

.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.vtd-font-weight-bold {
  font-weight: bolder;
}

.orange {
  color: orange;
  font-weight: bolder;
}
</style>